import React from "react";

import projectDiscord from "../../images/new/project/discord.svg";
import projectTwitter from "../../images/new/project/twitter.svg";
import projectwebsite from "../../images/website.svg";
import projectmail from "../../images/mail.svg";
import alien from "../../images/new/project/alien.png";
import menji from "../../images/new/project/menji.png";
import hippielifekrew from "../../images/new/project/hippielifekrew.png";
import cloudmachine from "../../images/new/project/cloudmachine.png";
import astrobaby from "../../images/new/project/astrobaby.png";
import space from "../../images/new/project/space.png";
import teens from "../../images/new/project/teens.png";
import cryptoon from "../../images/new/project/cryptoon.png";
import gabe from "../../images/new/project/gabe.png";
import smpl from "../../images/new/project/smpl.png";
import drunk from "../../images/new/project/drunk.png";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useEffect } from "react";
// importing aos
import AOS from 'aos';
import 'aos/dist/aos.css';

const sliderOptions = {
  center: true,
  items: 3,
  loop: true,
  margin: 0,
  nav: true,
  navText: ["<div class='nav-button owl-prev slide-left'></div>", "<div class='nav-button owl-next slide-right'></div>"],
  dots: false,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 3,
    },
  },
};
function ProjectSlider() {
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <section id="project" className="">
      <div className="wrapper">
        <h2 data-aos="fade-up" data-aos-delay="300">Project Collabs</h2>
        <div className="project-slider">
          <div className="owl-carousel pro-slider owl-theme"></div>

          <OwlCarousel className="pro-slider owl-theme" {...sliderOptions}>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={alien} alt="alien" />
                </div>
                <div className="details">
                  <h3>Alien Frens</h3>
                  <p>We come in peace</p>
                  <div className="social">
                    <a href="https://www.alienfrens.io/" target="_blank">
                      <img src={projectwebsite} />
                    </a>
                    <a href="https://twitter.com/alienfrens" target="_blank">
                      <img src={projectTwitter} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={smpl} alt="alien" />
                </div>
                <div className="details">
                  <h3>SMPL FRKS</h3>
                  <div className="social">
                    <a href="https://www.loveandnate.com/smplfrks" target="_blank">
                      <img src={projectwebsite} />
                    </a>
                    <a href="https://twitter.com/smplfrks" target="_blank">
                      <img src={projectTwitter} alt="" />
                    </a>
                    <a href="mailto:nate@loveandnate.com" target="_blank">
                      <img src={projectmail} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={menji} alt="menji" />
                </div>
                <div className="details">
                  <h3>Menji’s World</h3>
                  <div className="social">
                    <a href="https://menjisworld.com/home" target="_blank">
                      <img src={projectwebsite} />
                    </a>
                    <a href="https://twitter.com/menjisworld" target="_blank">
                      <img src={projectTwitter} alt="" />
                    </a>
                    <a href="https://twitter.com/M33NJi" target="_blank">
                      <img src={projectTwitter} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={cloudmachine} alt="cloudmachine" />
                </div>
                <div className="details">
                  <h3>Cloudmachine</h3>
                  <p>Ego Death and Creative Expansion</p>
                  <div className="social">
                    <a href="http://www.davevanpattenart.com/" target="_blank">
                      <img src={projectwebsite} alt="projectwebsite" />
                    </a>
                    <a href="https://twitter.com/cloudmachinenft" target="_blank">
                      <img src={projectTwitter} alt="projectTwitter" />
                    </a>
                    <a href="mailto:vanpattenart@gmail.com" target="_blank">
                      <img src={projectmail} alt="projectmail" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={astrobaby} alt="astrobaby" />
                </div>
                <div className="details">
                  <h3>Astrobaby NFT</h3>
                  <p>Healing baby</p>
                  <div className="social">
                    <a href="https://astrobaby.xyz/" target="_blank">
                      <img src={projectwebsite} alt="projectwebsite" />
                    </a>
                    <a href="https://twitter.com/FFey95" target="_blank">
                      <img src={projectTwitter} alt="projectTwitter" />
                    </a>
                    <a href="maito:feyfeyqu@gmail.com" target="_blank">
                      <img src={projectmail} alt="projectwebsite" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={space} alt="space" />
                </div>
                <div className="details">
                  <h3>Space Riders</h3>
                  <p>This Rider have been riding for a long time trying to master the art of healing and perfecting his meditation skills. </p>
                  <div className="social">
                    <a href="https://spaceriders.xyz/" target="_blank">
                      <img src={projectwebsite} alt="projectwebsite" />
                    </a>
                    <a href="https://twitter.com/cabralcf_" target="_blank">
                      <img src={projectTwitter} alt="projectTwitter" />
                    </a>
                    <a href="https://twitter.com/SpaceRiders_NFT" target="_blank">
                      <img src={projectTwitter} alt="projectTwitter" />
                    </a>
                    <a href="mailto:cabralcasillasf@gmail.com" target="_blank">
                      <img src={projectmail} alt="projectmail" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={teens} alt="teens" />
                </div>
                <div className="details">
                  <h3>Astrokid, Acidverse</h3>
                  <p>Astrokid has wandered far from the Acidverse and found himself in the realm of the Hippies</p>
                  <div className="social">
                    <a href="ttps://teensonacid.portfoliobox.net/" target="_blank">
                      <img src={projectwebsite} alt="projectwebsite" />
                    </a>
                    <a href="https://twitter.com/teensonacid" target="_blank">
                      <img src={projectTwitter} alt="projectTwitter" />
                    </a>
                    <a href="mailto:Josh@teensonacid.com" target="_blank">
                      <img src={projectmail} alt="projectmail" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={cryptoon} alt="cryptoon" />
                </div>
                <div className="details">
                  <h3>Cryptoon Goonz</h3>
                  <p>Goon at peace</p>
                  <div className="social">
                    <a href="https://www.cryptoongoonz.com/" target="_blank">
                      <img src={projectwebsite} alt="projectwebsite" />
                    </a>
                    <a href="https://twitter.com/Cryptoongoonz" target="_blank">
                      <img src={projectTwitter} alt="projectTwitter" />
                    </a>
                    <a href="mailto:drew@cryptoongoonz.com" target="_blank">
                      <img src={projectmail} alt="projectmail" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={gabe} alt="gabe" />
                </div>
                <div className="details">
                  <h3>Gabe Weis, The Stoics</h3>
                  <p>War. what is it good for?</p>
                  <div className="social">
                    <a href="https://www.thestoics.art/" target="_blank">
                      <img src={projectwebsite} alt="projectwebsite" />
                    </a>
                    <a href="https://twitter.com/GabrielJWeis" target="_blank">
                      <img src={projectTwitter} alt="projectTwitter" />
                    </a>
                    <a href="mailto:gabeweis@gmail.com" target="_blank">
                      <img src={projectmail} alt="projectmail" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="slider-body">
                <div className="img">
                  <img src={drunk} alt="drunk" />
                </div>
                <div className="details">
                  <h3>The Drunk Robots</h3>
                  <p>Hippie Robot</p>
                  <div className="social">
                    <a href="https://twitter.com/thedrunkrobots" target="_blank">
                      <img src={projectTwitter} alt="projectTwitter" />
                    </a>
                    <a href="mailto:team@drunkrobots.net" target="_blank">
                      <img src={projectmail} alt="projectmail" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </div>
    </section>
  );
}

export default ProjectSlider;
